export default __webpack_public_path__ + "static/media/AppleLaptop.e2c46a80.jpg";